import Api from './ApiService'

export default {
    get(keyword, pageNumber, pageSize, order, UserId) {
        return Api().get(`log?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}&UserId=${UserId}`);
    },
    getOne(id) {
        return Api().get(`log/${id}`);
    },
    create(data) {
        return Api().post(`log`, data);
    },
    update(data) {
        return Api().put(`log/${data.id}`, data);
    }
}